// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"0e605b9c","651":"b8c00615"}[chunkId] + ".chunk.js";
};